import type { PropsWithChildren } from "react";

import cn from "../../utils/cn.util";

export type BodyHeaderProps = {
  className?: string;
} & PropsWithChildren;

export const BodyHeader = ({ children, className }: BodyHeaderProps) => {
  return <div className={cn("flex items-center justify-between gap-2", className)}>{children}</div>;
};
